// extracted by mini-css-extract-plugin
export var assigneeBadge = "_hj-0";
export var assigneeDetails = "_hj-1";
export var assigneeInfo = "_hj-2";
export var dropdownContainer = "_hj-4";
export var dropdownImage = "_hj-5";
export var editAssigneeInfo = "_hj-3";
export var editAssigneeModalContainer = "_hj-6";
export var hidden = "_hj-8";
export var input = "_hj-7";